const forge = require("node-forge");

module.exports = {
  
  // encrypt 
  encrypt: (data, certKey) => {
    
    // console.log("data:", data);
    // console.log("certKey:", certKey);
    
    // create envelope
    var p7 = forge.pkcs7.createEnvelopedData();
    
    let cert = forge.pki.certificateFromPem(certKey);
    p7.addRecipient(cert);
    
    // set content to encrypt
    p7.content = forge.util.createBuffer(data);
    
    // encrypt the content
    p7.encrypt();
    
    return forge.pkcs7.messageToPem(p7);
  },
  
  
  // uses localStorage "store.keys" to decrypt
  decrypt: (data, pkey, cert) => {
    
    let store = localStorage.getItem("store");
    
    let p7 = forge.pkcs7.messageFromPem( data );
    // console.log("p7");
    // console.log(p7);
  
    let tcert = forge.pki.certificateFromPem( cert );
    // console.log("cert");
    // console.log(cert);
    
    let recipient = p7.findRecipient( tcert );
    // console.log("recipient");
    // console.log(recipient);
    
    let privateKey = forge.pki.privateKeyFromPem( pkey );
    // console.log("privateKey");
    // console.log(privateKey);
  
    p7.decrypt( recipient, privateKey );
    
    return p7.content.data;
    
  },
    
  
}